const callApi = async ({
  callback,
  payload = [],
  onSuccess = () => {},
  onError = () => {},
  setData = () => {},
}) => {
  // if (!callback) return false;
  // setData((prev) => ({ ...prev, loading: true }));
  try {
    // const reqPayload = Array.isArray(payload) ? payload : [payload];
    // const res = await callback(...reqPayload);
    // setData({ error: false, data: res, loading: false, catch: null });
    // if (onSuccess) onSuccess(res);
  } catch (error) {
    // console.log("error === callApi", error);
    // const status = error.response.status;
    // if (status === 401 || status === 403) {
    //   localStorage.removeItem("token");
    //   localStorage.removeItem("userProfile");
    //   window.location.replace("/login");
    // }
    // setData({ error: true, data: [], loading: false, catch: error });
    // if (onError) onError(error.response.data.message);
  }
};

export default callApi;
